import { render, staticRenderFns } from "./tour-card-left.vue?vue&type=template&id=5581e4a0&scoped=true&"
import script from "./tour-card-left.vue?vue&type=script&lang=js&"
export * from "./tour-card-left.vue?vue&type=script&lang=js&"
import style0 from "./tour-card-left.vue?vue&type=style&index=0&id=5581e4a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5581e4a0",
  null
  
)

export default component.exports